import { AWARE_PRODUCT_SKU_BEGINNING_CHARS, BWARE_PRODUCT_SKU_BEGINNING_CHARS } from '../../../constants/products';

export const convertBWareToAWare = (sku?: Maybe<string>) => {

  return sku?.replace(BWARE_PRODUCT_SKU_BEGINNING_CHARS, AWARE_PRODUCT_SKU_BEGINNING_CHARS) || '';

};

export const convertAWareToBWare = (sku?: Maybe<string>) => {

  return sku?.replace(AWARE_PRODUCT_SKU_BEGINNING_CHARS, BWARE_PRODUCT_SKU_BEGINNING_CHARS) || '';

};
